import React from 'react';

function Team() {
  return (
    <section className="team section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">The People Behind SPOB</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              Our <span className="fw-200">Founder</span>
            </h2>
            <div className="ml-auto">
              <a href="/light/page-contact" className="go-more">
                <span className="text">Get in touch</span>
                <span className="icon ti-arrow-top-right"></span>
              </a>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-5 md-mb50">
            <div className="item">
              <div className="img radius-15 overflow-hidden" style={{ position: 'relative' }}>
                <img
                  src="/light/assets/imgs/spob/director.jpg"
                  alt="Bankole Oladokun — Founder & Executive Director, SPOB Nigeria"
                  style={{ width: '100%', objectFit: 'cover', borderRadius: '15px' }}
                />
                <div
                  className="info"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'rgba(0,0,0,0.55)',
                    padding: '18px 24px',
                    borderRadius: '0 0 15px 15px',
                  }}
                >
                  <span className="fz-12" style={{ color: '#ccc', display: 'block', marginBottom: '4px' }}>
                    Founder &amp; Executive Director
                  </span>
                  <h6 className="fz-18" style={{ color: '#fff', margin: 0 }}>Bankole Oladokun</h6>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 offset-lg-1">
            <div className="content">
              <h6 className="sub-title main-color mb-30 fz-12 text-u ls3">
                Word from the Founder
              </h6>
              <blockquote style={{ borderLeft: '3px solid #c8a97e', paddingLeft: '28px', margin: 0 }}>
                <p className="fz-20 fw-400 line-height-40 mb-30">
                  &ldquo;SPOB was born from a simple, urgent truth &mdash; that millions of Nigerians are
                  held back not by lack of ability, but by lack of access. Access to healthcare,
                  to education, to a sense of cultural pride, to economic opportunity. We
                  started in 2018 with community volunteers and a shared conviction that
                  grassroots action, done consistently and with heart, can change lives.
                </p>
                <p className="fz-20 fw-400 line-height-40 mb-40">
                  Seven years on, every school uniform we provide, every health screening
                  we run, every young person who learns a trade through our programmes &mdash; each
                  one confirms why we do this work. We are not just building better communities;
                  we are building a better Nigeria, one person at a time.&rdquo;
                </p>
              </blockquote>
              <div className="d-flex align-items-center mt-10">
                <div>
                  <h6 className="fw-600 mb-5">Bankole Oladokun</h6>
                  <p className="fz-13 opacity-7">Founder &amp; Executive Director, SPOB Nigeria</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
